import ApplicationSerializer from 'eflex/serializers/application';

export default class DecisionDefConfigSerializer extends ApplicationSerializer {
  attrs = {
    taskConfig: {
      serialize: false,
      deserialize: false,
    },
  };
}
